import React from 'react';

import { Button } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

export const IconContainer = Button.withConfig({
  variant: 'ghost',
});

export const ActionButtonsContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.actionButtonsContainer, style],
  });

export const ActionLinkContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.actionLinkContainer, style],
  });

const styles = StyleSheet.create({
  actionButtonsContainer: {
    flexDirection: 'row',
    gap: spacing.$2,
    justifyContent: 'space-between',
    marginTop: spacing.$4,
  },
  actionLinkContainer: {
    flex: 1,
  },
});
